module.exports = {"450681100":"东兴镇","450681101":"江平镇","450681102":"马路镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450681.json
// module id = 1949
// module chunks = 0